import classNames from 'classnames';
import { DropdownIndicatorProps, components } from 'react-select';
import { Icon } from '../../icon/icon';
import styles from '../combobox.module.scss';
import { ComboboxOptions } from '../types';

export const DropdownIndicator = (props: DropdownIndicatorProps<ComboboxOptions[0], boolean>) => {
  const { selectProps } = props;
  return (
    <components.DropdownIndicator {...props}>
      <Icon
        className={classNames(styles.dropdownIcon, { [styles.menuIsOpen]: selectProps.menuIsOpen })}
        size={'24'}
        variant="chevron-down"
      />
    </components.DropdownIndicator>
  );
};
